import { SxProps } from '@mui/material';

export const learningPlanWrapperStyle: SxProps = {
  maxWidth: '770px',
  width: '100%',
  height: '325px'
};
